var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMfo = function SvgMfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mfo_svg__a)",
    d: "M1.428 6.997c.09-.153.183-.312.366-.36.222-.06 1.195.021 1.513.03.439.012.878.013 1.317.004 2.518-.066 4.8-.324 7.24-1.008a17.438 17.438 0 0 0 3.572-1.43c.451-.245.876-.534 1.313-.79.26-.152.695.064.729.361.053.26.078.528.11.793l.162 1.309.583 4.656.123.997c.017.148.068.62.115.744v.327c-.096.175-.304.504-.55.339-.16-.108-.285-.324-.421-.465a3.497 3.497 0 0 0-1.472-.912 3.543 3.543 0 0 0-2.662.242 3.49 3.49 0 0 0-1.773 2.305c-.112.447 0 1.113-.51 1.35-.332.153-.82.205-1.19.263a42.85 42.85 0 0 1-6.029.497c-.331.005-.709.025-1.037-.018-.474-.062-.453-.644-.502-1.04l-.158-1.28-.65-5.2c-.028-.215-.121-1.179-.19-1.303v-.412Zm8.428 6.185c.182-.028.363-.057.544-.087.29-.057.681-.066.854-.32a.521.521 0 0 0 .077-.396c-.165-.775-1.14-.232-1.64-.261-.052-.004-.105-.445-.114-.51.302-.059.605-.113.908-.162.699-.12 1.205-.245 1.637-.883.275-.412.374-.917.277-1.402a1.866 1.866 0 0 0-.8-1.193 1.75 1.75 0 0 0-.954-.298c-.32.005-.597.046-.91.109-.455.09-.927.144-1.379.249-.59.137-.364.794-.29 1.214l.626 3.544c.067.379.129.77.21 1.146a.425.425 0 0 0 .14.255.56.56 0 0 0 .403.154c.31-.01.523-.296.497-.595-.017-.19-.062-.375-.086-.564Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mfo_svg__b)",
    d: "M1.428 6.997c.09-.153.183-.312.366-.36.222-.06 1.195.021 1.513.03.439.012.878.013 1.317.004 2.518-.066 4.8-.324 7.24-1.008a17.438 17.438 0 0 0 3.572-1.43c.451-.245.876-.534 1.313-.79.26-.152.695.064.729.361.053.26.078.528.11.793l.162 1.309.583 4.656.123.997c.017.148.068.62.115.744v.327c-.096.175-.304.504-.55.339-.16-.108-.285-.324-.421-.465a3.497 3.497 0 0 0-1.472-.912 3.543 3.543 0 0 0-2.662.242 3.49 3.49 0 0 0-1.773 2.305c-.112.447 0 1.113-.51 1.35-.332.153-.82.205-1.19.263a42.85 42.85 0 0 1-6.029.497c-.331.005-.709.025-1.037-.018-.474-.062-.453-.644-.502-1.04l-.158-1.28-.65-5.2c-.028-.215-.121-1.179-.19-1.303v-.412Zm8.428 6.185c.182-.028.363-.057.544-.087.29-.057.681-.066.854-.32a.521.521 0 0 0 .077-.396c-.165-.775-1.14-.232-1.64-.261-.052-.004-.105-.445-.114-.51.302-.059.605-.113.908-.162.699-.12 1.205-.245 1.637-.883.275-.412.374-.917.277-1.402a1.866 1.866 0 0 0-.8-1.193 1.75 1.75 0 0 0-.954-.298c-.32.005-.597.046-.91.109-.455.09-.927.144-1.379.249-.59.137-.364.794-.29 1.214l.626 3.544c.067.379.129.77.21 1.146a.425.425 0 0 0 .14.255.56.56 0 0 0 .403.154c.31-.01.523-.296.497-.595-.017-.19-.062-.375-.086-.564Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mfo_svg__c)",
    d: "M10.427 8.74a.802.802 0 0 1 .915.594.815.815 0 0 1-.1.626c-.268.42-.784.396-1.23.492-.189.031-.46.068-.636.117-.059-.504-.186-1.092-.266-1.603.437-.067.875-.162 1.317-.227Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mfo_svg__d)",
    d: "M10.427 8.74a.802.802 0 0 1 .915.594.815.815 0 0 1-.1.626c-.268.42-.784.396-1.23.492-.189.031-.46.068-.636.117-.059-.504-.186-1.092-.266-1.603.437-.067.875-.162 1.317-.227Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mfo_svg__e)",
    d: "M10.28 2.329a4.26 4.26 0 0 1 2.21.468c.252.13 1.043.616 1.128.902a.231.231 0 0 1-.021.185c-.14.24-1.883.712-2.28.824-.333.086-.676.177-1.012.25-.076.016-.222.031-.289-.013-.185-.123-.3-.314-.44-.488a4.02 4.02 0 0 0-.386-.42c-.09-.085-.183-.165-.276-.246-.166-.166-.45-.265-.618-.419-.315-.288.149-.523.348-.617a4.503 4.503 0 0 1 1.636-.426Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mfo_svg__f)",
    d: "M10.28 2.329a4.26 4.26 0 0 1 2.21.468c.252.13 1.043.616 1.128.902a.231.231 0 0 1-.021.185c-.14.24-1.883.712-2.28.824-.333.086-.676.177-1.012.25-.076.016-.222.031-.289-.013-.185-.123-.3-.314-.44-.488a4.02 4.02 0 0 0-.386-.42c-.09-.085-.183-.165-.276-.246-.166-.166-.45-.265-.618-.419-.315-.288.149-.523.348-.617a4.503 4.503 0 0 1 1.636-.426Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mfo_svg__g)",
    d: "M6.047 3.936c.863-.034 1.579.193 2.258.736.224.18.479.494.03.636-.175.055-.456.072-.646.095-.52.065-1.042.113-1.565.144-.6.05-1.195.064-1.797.072a2.635 2.635 0 0 1-.559-.033c-.197-.188-.122-.362.044-.55.594-.678 1.344-1.022 2.235-1.1Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mfo_svg__h)",
    d: "M6.047 3.936c.863-.034 1.579.193 2.258.736.224.18.479.494.03.636-.175.055-.456.072-.646.095-.52.065-1.042.113-1.565.144-.6.05-1.195.064-1.797.072a2.635 2.635 0 0 1-.559-.033c-.197-.188-.122-.362.044-.55.594-.678 1.344-1.022 2.235-1.1Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mfo_svg__i)",
    d: "M14.903 12.508a2.411 2.411 0 1 1 .367 4.808 2.411 2.411 0 0 1-.367-4.808Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mfo_svg__j)",
    d: "M14.903 12.508a2.411 2.411 0 1 1 .367 4.808 2.411 2.411 0 0 1-.367-4.808Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mfo_svg__a",
    x1: 4.063,
    x2: 17.367,
    y1: 15.868,
    y2: 1.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#636F7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADDE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mfo_svg__b",
    x1: 4.063,
    x2: 17.367,
    y1: 15.868,
    y2: 1.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#5047D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBC9F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mfo_svg__c",
    x1: 4.063,
    x2: 17.367,
    y1: 15.868,
    y2: 1.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#636F7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADDE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mfo_svg__d",
    x1: 4.063,
    x2: 17.367,
    y1: 15.868,
    y2: 1.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#5047D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBC9F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mfo_svg__e",
    x1: 4.063,
    x2: 17.367,
    y1: 15.868,
    y2: 1.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#636F7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADDE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mfo_svg__f",
    x1: 4.063,
    x2: 17.367,
    y1: 15.868,
    y2: 1.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#5047D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBC9F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mfo_svg__g",
    x1: 4.063,
    x2: 17.367,
    y1: 15.868,
    y2: 1.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#636F7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADDE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mfo_svg__h",
    x1: 4.063,
    x2: 17.367,
    y1: 15.868,
    y2: 1.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#5047D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBC9F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mfo_svg__i",
    x1: 4.063,
    x2: 17.367,
    y1: 15.868,
    y2: 1.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#636F7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADDE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mfo_svg__j",
    x1: 4.063,
    x2: 17.367,
    y1: 15.868,
    y2: 1.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#5047D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBC9F3"
  })))));
};
export default SvgMfo;